export const plural = (props: SingularPlural) => {
  if (props.total === 0 || props.total > 1) return `${props.plural}`
  else return ``
}

interface SingularPlural {
  total: number
  plural: string
}
